import TextField from "../../../components/fields/textField/TextField.vue";
import TextAreaField from "../../../components/fields/textAreaField/TextAreaField.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import { ExercicioService } from "../../../services/ExercicioService";
import { AcaoService } from "../../../services/AcaoService";
import { SecaoService } from "../../../services/SecaoService";
import { GrupoService } from "../../../services/GrupoService";
import { ElementoItemService } from "../../../services/ElementoItemService";
import { IpgService } from "../../../services/IpgService";
import { IpuService } from "../../../services/IpuService";
import { PpagService } from "../../../services/PpagService";
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";

export default {
    name: "EditarPpag",
    props: {
        activeModal: {
            default: false,
            type: Boolean,
        }
    },
    components: {
        TextField,
        TextAreaField,
        SelectField,
        Breadcrumb
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de PPAG',
                disabled: false,
                href: '/gerenciar-ppag',
            },
            {
                text: 'Editar PPAG',
                disabled: true
            }
        ],
        ppag: {
            id: null,
            exercicio: '',
            codigo_ppag: '',
            detalhamento: '',
            gerencia: '',
            valor: '',
            acao_id: '',
            grupo_id: '',
            ipg_id: '',
            ipu_id: '',
            secao_id: '',
            elemento_item_id: '',
            ativo: true
        },
        exerciciosOptions: [],
        acoesOptions: [],
        secoesOptions: [],
        ipgsOptions: [],
        ipusOptions: [],
        gruposOptions: [],
        elementosItensOptions: [],
        loading: false,
    }),
    created() {
        this.carregarPpag(this.$route.params.id);
        this.listarExerciciosSelect();
        this.listarAcoesSelect();
        this.listarSecoesSelect();
        this.listarElementosItensSelect();
        this.listarGruposSelect();
        this.listarIpgsSelect();
        this.listarIpusSelect();
    },
    methods: {
        // Validação para aceitar apenas números no Código PPAG
        handleCodigoPpagInput(value) {
            // Remove tudo que não for número
            const numericValue = value.replace(/[^0-9]/g, '');
            this.ppag.codigo_ppag = numericValue;
        },

        // Validação para aceitar apenas números no Valor
        handleValorInput(value) {
            // Remove tudo que não for número ou ponto decimal
            const numericValue = value.replace(/[^0-9.]/g, '');
            this.ppag.valor = numericValue;
        },

        async carregarPpag(id) {
            try {
                this.loading = true;
                const response = await PpagService.show(id);

                if (response) {
                    const data = response.data;

                    this.ppag.id = data.id;
                    this.ppag.exercicio = data.exercicio?.ano || '';
                    this.ppag.codigo_ppag = data.codigo_ppag || '';
                    this.ppag.detalhamento = data.detalhamento || '';
                    this.ppag.gerencia = data.gerencia || '';
                    this.ppag.valor = data.valor || '';
                    this.ppag.acao_id = data.acao_id || '';
                    this.ppag.grupo_id = data.grupo_id || '';
                    this.ppag.ipg_id = data.ipg_id || '';
                    this.ppag.ipu_id = data.ipu_id || '';
                    this.ppag.secao_id = data.secao_id || '';
                    this.ppag.elemento_item_id = data.elemento_item_id || '';
                    this.ppag.ativo = data.ativo || false;
                    
                } else {
                    this.$store.dispatch('snackbar/showError', 'Não foi possível carregar os dados do PPAG.');
                }
            } catch (error) {
                console.error('Erro ao carregar PPAG:', error);
                this.$store.dispatch('snackbar/showError', 'Erro ao carregar os dados do PPAG.');
            } finally {
                this.loading = false;
            }
        },

        // Validação do formulário
        validateForm() {
            const requiredFields = [
                'exercicio', 'codigo_ppag', 'valor', 'gerencia', 
                'acao_id', 'secao_id', 'ipg_id', 'ipu_id', 'elemento_item_id'
            ];

            for (const field of requiredFields) {
                if (!this.ppag[field]) {
                    this.$store.dispatch('snackbar/showError', 'Por favor, preencha todos os campos obrigatórios');
                    return false;
                }
            }
            return true;
        },

        submitForm() {
            if (this.$refs.form.validate() && this.validateForm()) {
                this.salvarPpag();
            }
        },

        async salvarPpag() {
            try {
                this.loading = true;

                const formData = new FormData();

                // Adiciona todos os campos obrigatórios
                formData.append("exercicio", this.ppag.exercicio);
                formData.append("codigo_ppag", this.ppag.codigo_ppag);
                formData.append("gerencia", this.ppag.gerencia);
                formData.append("valor", this.ppag.valor);
                formData.append("acao_id", this.ppag.acao_id);
                formData.append("ipg_id", this.ppag.ipg_id);
                formData.append("ipu_id", this.ppag.ipu_id);
                formData.append("secao_id", this.ppag.secao_id);
                formData.append("elemento_item_id", this.ppag.elemento_item_id);
                
                // Campos opcionais - só adiciona se tiver valor
                if (this.ppag.grupo_id) {
                    formData.append("grupo_id", this.ppag.grupo_id);
                }
                
                if (this.ppag.detalhamento) {
                    formData.append("detalhamento", this.ppag.detalhamento);
                }

                formData.append("ativo", this.ppag.ativo ? 1 : 0);

                const response = await PpagService.update(this.ppag.id, formData);

                if (response) {
                    this.$store.dispatch('snackbar/showSuccess', 'PPAG atualizado com sucesso!');
                    
                    // Redirecionar para a tela de gerenciamento
                    this.$router.push('/gerenciar-ppag');
                } else {
                    this.$store.dispatch('snackbar/showError', 'Erro ao atualizar o PPAG.');
                }

            } catch (error) {
                console.error('Erro ao salvar PPAG:', error);
                this.$store.dispatch('snackbar/showError', 'Erro ao atualizar o PPAG. Tente novamente.');
            } finally {
                this.loading = false;
            }
        },

        cancelar() {
            // Retornar para a tela de gerenciamento sem salvar
            this.$router.push('/gerenciar-ppag');
        },

        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            }
        },

        async listarAcoesSelect() {
            try {
                const response = await AcaoService.select();
    
                if (response) {
                    this.acoesOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_acao} - ${el.descricao_acao}`,
                            value: el.id,
                        };
                    });
                    this.acoesOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });
    
                } else {
                    console.error('Não foi possível obter as ações.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar as ações:', error);
            }
        },

        async listarIpusSelect() {
            try {
                const response = await IpuService.select();
                if (response) {
                    this.ipusOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_ipu} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.ipusOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });
    
                } else {
                    console.error('Não foi possível obter os IPUs.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os IPUs:', error);
            }
        },

        async listarIpgsSelect() {
            try {
                const response = await IpgService.select();
                if (response) {
                    this.ipgsOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_ipg} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.ipgsOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });
    
                } else {
                    console.error('Não foi possível obter os IPGs.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os IPGs:', error);
            }
        },

        async listarGruposSelect() {
            try {
                const response = await GrupoService.select();
                if (response) {
                    this.gruposOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_grupo} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.gruposOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });
    
                } else {
                    console.error('Não foi possível obter os grupos.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os grupos:', error);
            }
        },

        async listarSecoesSelect() {
            try {
                const response = await SecaoService.select();
                if (response) {
                    this.secoesOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_secao}`,
                            value: el.id,
                        };
                    });
                    this.secoesOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });
    
                } else {
                    console.error('Não foi possível obter as seções.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar as seções:', error);
            }
        },

        async listarElementosItensSelect() {
            try {
                const response = await ElementoItemService.select();
                if (response) {
                    this.elementosItensOptions = response.data.map((el) => {
                        return {
                            text: `${el.codigo_elemento_item} - ${el.descricao}`,
                            value: el.id,
                        };
                    });
                    this.elementosItensOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });
    
                } else {
                    console.error('Não foi possível obter os elementos itens.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os elementos itens:', error);
            }
        },
    }
};
